import {
  Component,
  ViewEncapsulation,
  AfterContentChecked,
  ChangeDetectorRef,
  Injector,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { InsertMediaService } from '../../services/insert-media.service';
import { ImageRefModel, ImageObjectModel } from '../../model/image.model';
import { MediaRefModel, MediaObjectModel } from '../../model/media.model';
import { ContentService } from '../../components/shared/services/content.service';
import { NodeInfoService } from '../../services/node.service';
import { WkContentApiService } from '../../services/wk-content-api.service';
import { InsertMediaEvent } from '../../model/event.model';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'wk-insert-media',
  templateUrl: './wk-insert-media.component.html',
  styleUrls: ['./wk-insert-media.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WKInsertMediaComponent implements AfterContentChecked {
  selectedImage = true;
  contentBlocks = [{ label: 'Image' }, { label: 'Audio' }, { label: 'Video' }];
  selectedIndex = 0;
  imageRef: ImageRefModel;
  imageObj: ImageObjectModel;
  mediaRef: MediaRefModel;
  mediaObj: MediaObjectModel;
  mediaResource = 'pcicore:MediaResource';
  mediaTitle: any;
  insertMediaEvent: InsertMediaEvent;

  readonly dialogRef: MatDialogRef<WKInsertMediaComponent>;
  private readonly insertMediaService: InsertMediaService;
  private readonly cdr: ChangeDetectorRef;
  private readonly contentApiService: WkContentApiService;
  private readonly contentService: ContentService;
  private readonly nodeService: NodeInfoService;

  constructor(injector: Injector) {
    this.dialogRef =
      injector.get<MatDialogRef<WKInsertMediaComponent>>(MatDialogRef);
    this.insertMediaService =
      injector.get<InsertMediaService>(InsertMediaService);
    this.cdr = injector.get<ChangeDetectorRef>(ChangeDetectorRef);
    this.contentApiService =
      injector.get<WkContentApiService>(WkContentApiService);
    this.contentService = injector.get<ContentService>(ContentService);
    this.nodeService = injector.get<NodeInfoService>(NodeInfoService);

    this.imageObj = {
      images: [],
    };
    this.mediaObj = {
      medias: [],
    };
  }

  setMediaEvent(insertMediaEvent: InsertMediaEvent) {
    this.insertMediaEvent = insertMediaEvent;
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  closeDialog(): void {
    this.nodeService.setFolderId('');
    this.dialogRef.close();
    this.insertMediaEvent.editor?.focus();
  }

  onTabChange(event) {
    this.selectedIndex = event.index;
  }

  disabledInsertBtn() {
    if (
      this.insertMediaService.selectedNode &&
      this.insertMediaService.selectedNode.size > 0
    ) {
      return false;
    } else {
      return true;
    }
  }

  getMedia(id: string) {
    return this.contentService.getNodeContentUrl(id);
  }

  getImageHeightWidth(id: string) {
    const imageHeightWidth = new Image();
    imageHeightWidth.src = this.getMediaForHeightAndWidth(id);
    const imgHeight = imageHeightWidth.height;
    const imgWidth = imageHeightWidth.width;
    const img = {};
    img['height'] = imgHeight;
    img['width'] = imgWidth;
    return img;
  }

  async getMediaTitle(id: string): Promise<void> {
    const node = await firstValueFrom(this.contentApiService.getNodeInfo(id));
    this.mediaTitle = node.properties['cm:title'] || node.name;
  }

  getMediaForHeightAndWidth(id: string) {
    return this.contentApiService.getContentUrl(id);
  }

  insertImage() {
    this.insertMediaService.selectedNode.forEach((element) => {
      const tenantId = element.entry.properties['apollo:tenantId'];
      if (this.selectedIndex === 0) {
        const image = this.getImageHeightWidth(element.entry.id);
        this.imageRef = new ImageRefModel(
          this.getMedia(tenantId),
          this.getMedia(tenantId),
          this.mediaResource,
          element.entry.name,
          image['height'],
          image['width'],
          tenantId
        );
        this.imageObj.images.push(this.imageRef);
      }
      if (this.selectedIndex === 1 || this.selectedIndex === 2) {
        this.insertMedia(element);
      }
    });
    if (this.imageObj.images.length > 0) {
      this.insertMediaService.setImageDetails(this.imageObj.images);
    }
    this.closeDialog();
  }

  async insertMedia(element) {
    const tenantId = element.entry.properties['apollo:tenantId'];
    await this.getMediaTitle(element.entry.id);
    this.mediaRef = new MediaRefModel(
      this.getMedia(tenantId),
      this.getMedia(tenantId),
      this.mediaResource,
      element.entry.name,
      this.mediaTitle,
      tenantId
    );
    this.mediaObj.medias.push(this.mediaRef);
    if (this.mediaObj.medias.length > 0) {
      if (this.selectedIndex === 1) {
        this.insertMediaService.setAudioDetails(this.mediaObj.medias);
      } else if (this.selectedIndex === 2) {
        this.insertMediaService.setVideoDetails(this.mediaObj.medias);
      }
    }
  }
}
